import { FETCH_MY_TASKS } from 'stores/redux/actions/types';
import reducer from '../common/reducer';

const addReducer = reducer(FETCH_MY_TASKS);
export default addReducer;
